import React, { Component } from 'react';
import lottie from 'lottie-web';
import loader from '../../assets/animations/loader.json';
import './loader.scss';

/** @extends {Component} */
class Loader extends Component {
  animationEl = React.createRef();

  constructor(/** @type {object} */ props) {
    super(props);
  }

  componentDidMount() {
    lottie.loadAnimation({
      container: this.animationEl.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: loader
    });
  }

  render() {
    return (
      <section className="loader">
        <div className="loader__container">
          <div className="loader__graphic" ref={this.animationEl} />
          <p className="loader__text">Loading...</p>
        </div>
      </section>
    );
  }
}

export default Loader;
